import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { ScrollRestoration, useLocation } from "react-router"

import { TableProvider } from "@sap/hooks/session-storage/tables"

import queryClient from "@/api/admin/queryClient"
import AuthGuard from "@/guard/AuthGuard"
import AlgoliaProvider from "@/utils/algolia"
import AnalyticsProvider from "@/utils/posthog"

import { DomainProvider } from "./originals"

export function RootProviders({ children }: { children: React.ReactNode }) {
  return (
    <>
      <NormalizePathname />
      <ScrollRestoration />
      <DomainProvider>
        <AnalyticsProvider>{children}</AnalyticsProvider>
      </DomainProvider>
    </>
  )
}

function NormalizePathname() {
  const location = useLocation()

  if (location.pathname.includes("//")) {
    window.location.href = "/"
  }

  return null
}

export function MainProviders({ children }: { children: React.ReactNode }) {
  return (
    <AuthGuard>
      <AlgoliaProvider>{children}</AlgoliaProvider>
    </AuthGuard>
  )
}

export function AdminProviders({ children }: { children: React.ReactNode }) {
  return (
    <AuthGuard>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools
          initialIsOpen={false}
          client={queryClient}
          buttonPosition="bottom-left"
        />
        <TableProvider>{children}</TableProvider>
      </QueryClientProvider>
    </AuthGuard>
  )
}
